import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "q-pa-sm text-center text-grey-6"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("em", null, "This post has no media.", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.media)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.isEmbed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_q_img, {
                  src: _ctx.media.thumbnail,
                  ratio: _ctx.aspectRatio,
                  class: _normalizeClass({'cursor-pointer': _ctx.canShowPost}),
                  onClick: _ctx.openPostModal
                }, null, 8, ["src", "ratio", "class", "onClick"]),
                _createVNode(_component_q_btn, {
                  label: "View Video",
                  class: "full-width",
                  flat: "",
                  "no-caps": "",
                  onClick: _ctx.openEmbedModal
                }, null, 8, ["onClick"])
              ]))
            : (_ctx.isVideo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("video", {
                    src: _ctx.media.url,
                    preload: "metadata",
                    width: "100%",
                    controls: ""
                  }, null, 8, _hoisted_4),
                  (_ctx.hasFeat('TRANSCRIBE'))
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        flat: "",
                        round: "",
                        onClick: _ctx.openPostTranscriptModal,
                        title: "View Transcript",
                        style: {"position":"absolute","top":"10px","right":"10px","z-index":"10"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "fa fa-closed-captioning",
                            size: "1.5rem"
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_q_img, {
                  key: 2,
                  src: _ctx.media.url,
                  ratio: _ctx.aspectRatio,
                  class: _normalizeClass({'cursor-pointer': _ctx.canShowPost}),
                  onClick: _ctx.openPostModal
                }, null, 8, ["src", "ratio", "class", "onClick"]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
  ]))
}